<template>
  <div class="order-card">
    <!-- 订单头 -->
    <div class="order-header">
      <el-checkbox v-model="localChecked" @change="onCheckedChange" />
      <span class="order-no">订单号：{{ order.idOfStr }}</span>
      <span class="order-account">下单账号：{{ order.buyerID }}</span>
      <span class="order-time">{{ order.modifyTime }}</span>
      <span class="order-time" style="margin-left: 40px;color: #1481d1">金额：{{ formatMoney(order.totalAmount) }}(含运费：{{ formatMoney(order.shippingFee) }})</span>
    </div>

    <!-- 商品列表 -->
    <div
        v-for="(item,i) in order.productItems"
        :key="i"
        class="order-item"
    >
      <el-image
          :src="item.productImgUrl[0]" class="product-img"
          :preview-src-list="[item.productImgUrl[0]]">
      </el-image>
<!--      <img :src="item.productImgUrl[0]" class="product-img" />-->

      <div class="product-info">
        <div class="title">{{ item.name }}</div>
        <div class="spec">
          <span v-for="(tag,index) in item.skuInfos" :key="index">{{ tag.name }}: {{tag.value}};</span>
        </div>
        <div class="tags">
          <span v-for="(tag,index) in item.guaranteesTerms" :key="index">{{ tag.qualityAssuranceType }}</span>
        </div>
      </div>

<!--      <div class="price">¥ {{ item.price }}</div>-->
      <div class="qty">{{ formatMoney(item.price) }} * {{ item.quantity }}</div>
      <div class="status">{{ item.statusStr }}</div>

<!--      <div class="total">
        <div class="amount">¥ {{ order.total }}</div>
        <div class="freight">含运费 {{ order.freight }}</div>
      </div>

      <div class="actions">
        <el-button size="mini" type="primary">再购买</el-button>
        <el-button size="mini" plain>订单详情</el-button>
      </div>-->
    </div>
  </div>
</template>

<script>
import {formatMoney} from '@/assets/js/utils'
export default {
  name: 'OrderCard',
  props: {
    order: {
      type: Object,
      required: true,
      default: () => ({ productItems: [] })
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      formatMoney
    }
  },
  computed: {
    // ⭐ 核心：中转 computed
    localChecked: {
      get() {
        return this.checked
      },
      set(val) {
        this.$emit('checked-change', {
          order: this.order,
          checked: val
        })
      }
    }
  },
  methods: {
    onCheckedChange(val) {
      this.$emit('checked-change', {
        checked: val,
        order: this.order
      })
    }
  }
}
</script>

<style scoped lang="less">
.order-card {
  background: #fff;
  border: 1px solid #eee;
  margin-bottom: 16px;
}

/* 头部 */
.order-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 16px;
  background: #f7f7f7;
  font-size: 13px;
}

/* 商品行 */
.order-item {
  display: grid;
  grid-template-columns: 60px 1fr 150px 140px;
  //grid-template-columns: 60px 1fr 140px 100px 140px;
  gap: 20px;
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  ::v-deep img{
    width: 60px!important;
    height: 60px!important;
  }
}

.product-info .title {
  font-size: 14px;
  font-weight: 500;
}

.spec {
  font-size: 12px;
  color: #999;
}

.tags span {
  color: #1aad19;
  font-size: 12px;
  margin-right: 6px;
}

.price,
.qty,
.status {
  text-align: center;
}

.total {
  text-align: right;
}

.amount {
  font-size: 16px;
  font-weight: bold;
}

.freight {
  font-size: 12px;
  color: #999;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
